import { IconType } from "@twinkltech/curriculum-architect-component-library";

export const getDefaultSubjectIcon = ({ slug }: { slug: string }): IconType => {
  switch (slug) {
    case "art":
      return "Palette";
    case "computing":
      return "Computer";
    case "design-tech":
      return "DrawAbstract";
    case "english":
      return "AutoStories";
    case "foriegn-language":
      return "Chat";
    case "french":
      return "Chat";
    case "geography":
      return "Public";
    case "handwriting":
      return "Draw";
    case "history":
      return "AccountBalance";
    case "mathematics":
      return "Calculate";
    case "music":
      return "MusicNote";
    case "physical-education":
      return "SportsHandball";
    case "pshe":
      return "Psychiatry";
    case "religion-worldviews":
      return "Diversity3";
    case "science":
      return "Experiment";
    case "spanish":
      return "Chat";
    case "spelling":
      return "Spellcheck";
    default:
      return "School";
  }
};
